export default __webpack_public_path__ + "static/media/blazer.b458f52b.jpg";